import React, { useEffect } from "react";
import "./Terms_Conditions.css";
import Common_title from "../common-components/common-title/Common_title";

import { useDispatch, useSelector } from "react-redux";
import { getTerms_and_Conditions } from "../../features/terms_conditions.js/Slice";

const Terms_Conditions = () => {
  const dispatch = useDispatch();
  const termsconditions = useSelector(
    (state) => state.termsconditions.termscondition
  );

  useEffect(() => {
    dispatch(getTerms_and_Conditions());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <section className="Terms_Conditions">
      <div className="container-fluid">
        <Common_title title="Terms" titleblack=" & condition" />
        <div className="content_div">
          {termsconditions && termsconditions.content ? (
            <div
              className="description_text"
              dangerouslySetInnerHTML={{ __html: termsconditions.content }}
            />
          ) : (
            <p className="no-data">No Terms and Conditions Available</p>
          )}
        </div>
        
      </div>
    </section>
  );
};

export default Terms_Conditions;